import { FormTemplateFieldConditionalRule } from 'mapistry-shared';

export const EMPTY_CONDITIONAL_RULE: Partial<FormTemplateFieldConditionalRule> =
  {
    operator: undefined,
    conditionalFieldValues: null,
    conditionallyShownFields: [
      { id: '', hideInPdfIfConditionallyHidden: false },
    ],
  };
